export const deviceList = [
    {
        name: 'pMDI',
        description: 'Pressurized Metered Dose Inhaler',
        image: 'pMDI-inhaler',
        optimalMin: 20,
        optimalMax: 60,
        // resistanceFactor: 1,
        resistanceFactor: 3.2,
        diam:30,
        multiplier:26.3405
    },
    {
        name: 'SMI',
        description: 'Soft Mist Inhaler',
        image: 'smi-inhaler',
        optimalMin: 20,
        optimalMax: 60,
        // resistanceFactor: 1,
        resistanceFactor: 3.2,
        diam:30,
        multiplier:26.3405
    },
    {
        name: 'DPI',
        description: 'Dry Powder Inhaler',
        image: 'dpi-inhaler-1',
        optimalMin: 30,
        optimalMax: 90,
        // resistanceFactor: 0.83,
        resistanceFactor: 3.2,
        diam:25.4,
        multiplier:35.422418
    },
    {
        name: 'DPI',
        description: 'Dry Powder Inhaler',
        image: 'dpi-inhaler-2',
        optimalMin: 30,
        optimalMax: 200,
        // resistanceFactor: 0.664,
        resistanceFactor: 3.2,
        diam:19.9,
        multiplier:49.3114855
    },
    {
        name: 'DPI',
        description: 'Dry Powder Inhaler',
        image: 'dpi-inhaler-3',
        optimalMin: 30,
        optimalMax: 200,
        // resistanceFactor: 0.664,
        resistanceFactor: 3.2,
        diam:19.9,
        multiplier:49.3114855
    },
    {
        name: 'DPI',
        description: 'Dry Powder Inhaler',
        image: 'dpi-inhaler-4',
        optimalMin: 30,
        optimalMax: 200,
        // resistanceFactor: 0.498,
        resistanceFactor: 3.2,
        diam:16.4,
        multiplier:59.868308
    },
    {
        name: 'DPI',
        description: 'Dry Powder Inhaler',
        image: 'dpi-inhaler-5',
        optimalMin: 30,
        optimalMax: 200,
        // resistanceFactor: 0.332,
        resistanceFactor: 3.2,
        diam:14.2,
        multiplier:67.188082
    },
    {
        name: 'DPI',
        description: 'Dry Powder Inhaler',
        image: 'dpi-inhaler-6',
        optimalMin: 30,
        optimalMax: 200,
        // resistanceFactor: 0.166,
        resistanceFactor: 3.2,
        diam:9.2,
        multiplier:85.787732
    },
]